import { render, staticRenderFns } from "./messaging_single_room.vue?vue&type=template&id=71ced822&scoped=true"
import script from "./messaging_single_room.vue?vue&type=script&lang=js"
export * from "./messaging_single_room.vue?vue&type=script&lang=js"
import style0 from "./messaging_single_room.vue?vue&type=style&index=0&id=71ced822&prod&lang=css"
import style1 from "./messaging_single_room.vue?vue&type=style&index=1&id=71ced822&prod&scoped=true&lang=css"
import style2 from "./messaging_single_room.vue?vue&type=style&index=2&id=71ced822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ced822",
  null
  
)

export default component.exports